'use strict';

var React = require('react'),
    IconMixin = require('../../mixins/IconMixin');

var LikeIcon = React.createClass({
  mixins: [IconMixin],

  renderSVG: function (size) {
    switch (size) {
    case 'small':
      return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M9 16c4.25-3.26 8-5.15 8-9.68C17 3.67 14.92 2 12.86 2 11.27 2 9.66 2.87 9 4.69 8.33 2.87 6.73 2 5.14 2 3.08 2 1 3.67 1 6.32 1 10.85 4.75 12.74 9 16z"/>';
    case 'medium':
      return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M16 30c7.96-6.06 15-9.56 15-17.98C31 7.11 27.1 4 23.24 4 20.26 4 17.25 5.61 16 8.99 14.75 5.61 11.74 4 8.76 4 4.9 4 1 7.11 1 12.02 1 20.44 8.04 23.94 16 30z"/>';
    case 'large':
      return '<path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M24 45c11.94-9.32 22.5-14.7 22.5-27.65C46.5 9.78 40.65 5 34.86 5 30.4 5 25.87 7.48 24 12.69 22.13 7.48 17.6 5 13.14 5 7.35 5 1.5 9.78 1.5 17.35 1.5 30.3 12.06 35.68 24 45z"/>';
    }
  }
});

module.exports = LikeIcon;


/** WEBPACK FOOTER **
 ** ./atoms/icons/Like.jsx
 **/